import React, { useContext, useEffect, useState } from 'react';
import { ArchivoxApi } from '../apis';
import { Archivox } from '../types';
const $Context = React.createContext(null);
export const ArchivoxProvider = (props) => {
    const context = new ArchivoxApi(props.apis);
    return React.createElement($Context.Provider, { value: context }, props.children);
};
export const useArchivox = (props = {}) => {
    const context = useContext($Context);
    const [state, setState] = useState([true, null]);
    useEffect(() => {
        Promise.all([
            props.countries ? context.getCountriesAsync() : Promise.resolve([]),
            props.departments ? context.getDepartmentsAsync() : Promise.resolve([]),
            props.cities ? context.getCitiesAsync() : Promise.resolve([]),
            props.profiles ? context.getProfilesAsync() : Promise.resolve([]),
            props.roles ? context.getRolesAsync() : Promise.resolve([]),
            props.sections ? context.getSectionsAsync() : Promise.resolve([]),
            props.series ? context.getSeriesAsync() : Promise.resolve([]),
            props.subseries ? context.getSubseriesAsync() : Promise.resolve([]),
            props.trdVersions ? context.getTrdVersionsAsync() : Promise.resolve([]),
            props.users ? context.getUsersAsync() : Promise.resolve([])
        ]).then((data) => {
            const [countries, departments, cities, profiles, roles, sections, series, subseries, trdVersions, users] = data;
            const instance = new Archivox({
                cities,
                countries,
                departments,
                profiles,
                roles,
                sections,
                series,
                subseries,
                trdVersions,
                users
            });
            setState([false, instance]);
        });
    }, []);
    if (context == null)
        throw new Error('No es posible acceder al contexto de archivox, verifique que el componente esté dentro del proveedor <ArchivoxProvider />');
    return state;
};
